// import React from "react";
// import "../Components/CSS/Navbar.css";
// import { FaBell } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const Navbar = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="navbar">
//       <div className="nav-left">
//         <div className="search-box">
//           <input type="text" placeholder="Search products, orders" />
//         </div>
//       </div>

//       <div className="nav-right">
//         <div
//           className="bell"
//           onClick={() => navigate("/notifications")}
//           style={{ cursor: "pointer" }}
//         >
//           <FaBell />
//           <span className="dot"></span>
//         </div>

//         {/* CLICKABLE PROFILE */}
//         <div
//           className="profile"
//           onClick={() => navigate("/admin-profile")}
//           style={{ cursor: "pointer" }}
//         >
//           <div className="profile-text">
//             <span className="name">Prachi Kunjir</span>
//             <span className="role">Administrator</span>
//           </div>

//           <div className="avatar">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width="25"
//               height="25"
//               viewBox="0 0 24 24"
//               fill="none"
//             >
//               <path
//                 d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21"
//                 stroke="#fff"
//                 stroke-width="2"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               />
//               <path
//                 d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
//                 stroke="#fff"
//                 stroke-width="2"
//                 stroke-linecap="round"
//                 stroke-linejoin="round"
//               />
//             </svg>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbar;



// // import React from "react";
// // import "../Components/CSS/Navbar.css";
// // import { FaBell } from "react-icons/fa";
// // import { useNavigate } from "react-router-dom";

// // const Navbar = ({ searchTerm, setSearchTerm }) => {
// //   const navigate = useNavigate();

// //   return (
// //     <div className="navbar">
// //       <div className="nav-left">
// //         <div className="search-box">
// //           <input
// //             type="text"
// //             placeholder="Search products, orders"
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //           />
// //         </div>
// //       </div>

// //       <div className="nav-right">
// //         <div
// //           className="bell"
// //           onClick={() => navigate("/notifications")}
// //           style={{ cursor: "pointer" }}
// //         >
// //           <FaBell />
// //           <span className="dot"></span>
// //         </div>

// //         <div
// //           className="profile"
// //           onClick={() => navigate("/admin-profile")}
// //           style={{ cursor: "pointer" }}
// //         >
// //           <div className="profile-text">
// //             <span className="name">Prachi Kunjir</span>
// //             <span className="role">Administrator</span>
// //           </div>

// //           <div className="avatar">
// //             Avatar
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Navbar;


import React, {
  useEffect,
  useState,
} from "react";

import "../Components/CSS/Navbar.css";

import { FaBell } from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import { API_BASE, FILE_BASE } from "../config";

const Navbar = () => {
  const navigate = useNavigate();

  const [profile, setProfile] =
    useState(null);

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const token =
        localStorage.getItem("token");

      const response = await fetch(
        `${API_BASE}/admin-auth/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to load profile"
        );
      }

      const data = await response.json();

      setProfile(data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="navbar">
      <div className="nav-left">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search products, orders"
          />
        </div>
      </div>

      <div className="nav-right">
        <div
          className="bell"
          onClick={() =>
            navigate("/notifications")
          }
          style={{ cursor: "pointer" }}
        >
          <FaBell />

          <span className="dot"></span>
        </div>

        {/* PROFILE */}
        <div
          className="profile"
          onClick={() =>
            navigate("/admin-profile")
          }
          style={{ cursor: "pointer" }}
        >
          <div className="profile-text">
            <span className="name">
              {profile?.name ||
                "Admin"}
            </span>

            <span className="role">
              {profile?.role ||
                "Administrator"}
            </span>
          </div>

          <div className="avatar">
            {profile?.profileImage ? (
              <img
                src={
                  profile.profileImage
                }
                alt="Profile"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M19 21V19C19 17.9391 18.5786 16.9217 17.8284 16.1716C17.0783 15.4214 16.0609 15 15 15H9C7.93913 15 6.92172 15.4214 6.17157 16.1716C5.42143 16.9217 5 17.9391 5 19V21"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />

                <path
                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;